
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import range from 'lodash/range'
import classnames from 'classnames'
import Icon from 'components/Icon'
import PagerButton from './PagerButton'

export default class Pager extends React.PureComponent {
  static propTypes = {
    max: PropTypes.number.isRequired,
    page: PropTypes.number,
    onPageSelect: PropTypes.func,
    maxShownPages: PropTypes.number,
    className: PropTypes.string
  }

  static defaultProps = {
    maxShownPages: 7
  }

  render() {
    const {className} = this.props
    const classNames = classnames('pager', className)
    return (
      <div className={classNames}>
        {this.renderPrevButton()}
        {this.renderPagerBody()}
        {this.renderNextButton()}
      </div>
    )
  }

  renderPagerBody() {
    const {max, maxShownPages} = this.props

    if (max < maxShownPages) {
      return range(1, max + 1).map(item => ({value: item, title: item})).map(this.renderButton)
    } else {
      const pageSize = this.getPageSize()
      const currentPage = this.getCurrentPage()

      const start = (currentPage * pageSize)
      const end = Math.min(start + pageSize, max - 4)
      const endShift = (end - start) - pageSize
      const pages = range(start + 3 + endShift, end + 3).map(item => ({value: item, title: item}))

      return [
        {title: '1', value: 1},
        this.getPrevPageButton(),
        ...pages,
        this.getNextPageButton(),
        {title: max, value: max}
      ].map(this.renderButton)
    }
  }

  renderButton = ({title, value}, index) => {
    const {page, onPageSelect} = this.props
    const isActive = value === page

    return (
      <PagerButton
        title={title}
        value={value}
        onClick={!isActive ? onPageSelect : null}
        active={isActive}
        key={index}
      />
    )
  }

  renderPrevButton() {
    const {page, onPageSelect} = this.props
    const disabled = page === 1
    const className = classnames('pager_button', 'is-prev', {'is-disabled': disabled})

    return (
      <div
        className={className}
        onClick={!disabled ? () => onPageSelect(page - 1) : null}
      >
        <Icon className='pager_button-prev-icon' name='chevron' size='12px' />
      </div>
    )
  }

  renderNextButton() {
    const {page, max, onPageSelect} = this.props
    const disabled = page === max
    const className = classnames('pager_button', 'is-next', {'is-disabled': disabled})

    return (
      <div
        className={className}
        onClick={!disabled ? () => onPageSelect(page + 1) : null}
      >
        <Icon className='pager_button-next-icon' name='chevron' size='12px' />
      </div>
    )
  }

  getPrevPageButton() {
    const currentPage = this.getCurrentPage()
    const pageSize = this.getPageSize()
    const isFirstPage = currentPage === 0

    return {
      title: isFirstPage ? '2' : '...',
      value: isFirstPage ? 2 : ((currentPage - 1) * pageSize) + 3
    }
  }

  getNextPageButton() {
    const {max} = this.props
    const currentPage = this.getCurrentPage()
    const pageSize = this.getPageSize()
    const isLastPage = this.getPageIndex(max - 2) === currentPage

    return {
      title: isLastPage ? max - 1 : '...',
      value: isLastPage ? max - 1 : ((currentPage + 1) * pageSize) + 3
    }
  }

  getCurrentPage() {
    const {page, max} = this.props

    return Math.min(this.getPageIndex(page), this.getPageIndex(max - 2))
  }

  getPageIndex(page) {
    const {max} = this.props
    const pageSize = this.getPageSize()

    // toFixed is to avoid decimal fractions problem
    return Math.max(Math.floor(((max / pageSize) * ((page - 3) / max)).toFixed(2)), 0)
  }

  getPageSize() {
    const {maxShownPages} = this.props
    return Math.max(maxShownPages - 4, 1)
  }
}



// WEBPACK FOOTER //
// ./client/components/Pager/index.js